import script from "./ProductImages.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductImages.vue?vue&type=script&lang=ts&setup=true"

import "./ProductImages.vue?vue&type=style&index=0&id=56f133dc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f133dc"]])

export default __exports__